import type React from "react";
import { getTimestampInLocalTime } from "@/util/dateUtil";
import { Box, Grid2 as Grid, Typography } from "@mui/material";
import StatusLabel from "../StatusLabel/CreditRequestStatusLabel";
import { ChevronRight } from "@mui/icons-material";

export type CreditRequestReversalListItemProps = {
    reversal: CreditRequestReversals;
}

export type CreditRequestReversals = {
    id: string;
    friendlyId: string;
    dateCreated: string;
    status: string;
    totalCostInc: number;
}

export const CreditRequestReversalListItem: React.FC<CreditRequestReversalListItemProps> = ({
    reversal
}) => {
    return (
    <>
        <Grid container size="grow">
            <Grid size={7} sx={{ pl: 1 }}>
                <Typography
                    variant="caption"
                    color="textSecondary"
                    display="inline"
                >
                    Reversal No
                </Typography>
                <Typography variant="body2" display="block">
                    {reversal.friendlyId}
                </Typography>
                <Typography
                    variant="caption"
                    color="textSecondary"
                    display="inline"
                >
                    Date Created
                </Typography>
                <Typography variant="body2" display="block">
                    {getTimestampInLocalTime(reversal.dateCreated, "dd/MM/yyyy")}
                </Typography>
            </Grid>
            <Grid size={4} sx={{ pl: 2 }}>
                <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    <Box>
                        <Typography
                            variant="caption"
                            color="textSecondary"
                            display="inline"
                        >
                            Total Cost Inc.
                        </Typography>
                        <Typography variant="body2" display="block">
                            ${reversal.totalCostInc.toFixed(2)}
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                        <StatusLabel status={reversal.status}/>
                    </Box>
                </Box>
            </Grid>
            <Grid container size={1} alignItems="center">
                <ChevronRight/>
            </Grid>
        </Grid>
    </>)
}